import React from "react";
import Sharingan from "../ItachiEyePassword/itachiEyePassword";

export default function ConfirmPasswordInput({
  confirmPassword,
  setConfirmPassword,
  showConfirmPassword,
  handleSharinganClickconfirm,
  errors,
  passwordsMatch,
}) {
  return (
    <>
      <div className="sp-form-input-pass-wrapper">
        <div className="sp-form-input-pass">
          <input
            className="form-input-pass"
            style={
              showConfirmPassword
                ? { fontFamily: "comica, cursive" }
                : { fontFamily: "Courier New, monospace" }
            }
            type={showConfirmPassword ? "text" : "password"}
            id="ConfirmPassword"
            name="ConfirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <label className="form-floating-label-pass" htmlFor="ConfirmPassword">
            CONFIRM PASSWORD
          </label>
          <Sharingan onLoginClick={handleSharinganClickconfirm} />
        </div>
        <div className="sp-form-password-strength">
          {confirmPassword && (
            <p className={passwordsMatch ? "valid" : "invalid"}>
              {passwordsMatch ? "MATCHED" : "NOT MATCHED"}
            </p>
          )}
        </div>
      </div>

      <div className="sp-validation-error-pass">
        {errors.confirmPassword && <span>{errors.confirmPassword}</span>}
      </div>
    </>
  );
}
